import React from 'react';
import { MdOpenInNew } from 'react-icons/md';
import { useOrganizationBranding } from './hooks';
import { frontendUrl } from './frontendUrls';

export default function ModuleAccessLink({ module }) {
  const { data } = useOrganizationBranding();
  return <a className="btn btn-outline-secondary system-module-access" target="_blank" rel="noopener noreferrer"
    href={frontendUrl(module, data)} title="Abrir módulo em outra aba">Acessar <MdOpenInNew size={17} aria-hidden="true" /></a>;
}
